import React, { useEffect } from 'react'
import { Button, Modal } from '../../components'
import ErrorMessage from '../../components/Form/ErrorMessage'

export const ResponseSendModal = ({
  title,
  body,
  show,
  onHide,
  titleAlign,
  onConfirm,
  onCancel,
  ...rest
}) => {
  const [error, setError] = React.useState('')

  useEffect(() => {
    if (show) {
      setError('')
    }
  }, [show])

  return (
    <Modal show={show} onHide={onHide} size={'xm'} {...rest}>
      <Modal.Header closeButton>
        <Modal.Title align={titleAlign}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
        {error && (
          <Modal.Container
            align={'center'}
            justify={'center'}
            margin={'1rem 0 0'}
            width={'100%'}
          >
            <ErrorMessage>{error}</ErrorMessage>
          </Modal.Container>
        )}
      </Modal.Body>
      <Modal.Footer align="center">
        <Button
          text="Não"
          width="120px"
          variant="outlined"
          onClick={() => {
            onCancel?.()
            onHide?.(false)
          }}
        />
        <Button
          text="Sim"
          width="120px"
          variant="primary"
          onClick={async () => {
            const resp = await onConfirm?.()
            if (!resp?.error) {
              onHide?.(false)
              return
            }
            setError(resp?.message)
          }}
        />
      </Modal.Footer>
    </Modal>
  )
}
